export type RawPartnerAccountSettings = {
  featureFlags: RawPartnerFeatureFlags
  productSettings: PartnerProductSettings
}

export type PartnerAccountSettings = { featureFlags: PartnerFeatureFlags; productSettings: PartnerProductSettings }

export type PartnerProductSettings = {
  hideCanceledAccountsFromDropdowns: boolean
}

export const DEFAULT_PARTNER_PRODUCT_SETTINGS: PartnerProductSettings = {
  hideCanceledAccountsFromDropdowns: false,
}

export type RawPartnerFeatureFlags = {
  'gtre-msp-agent-access-license-driven-enabled': boolean
}

export type PartnerFeatureFlags = {
  gtreMspAgentAccessLicenseDrivenEnabled: boolean
}

export const DEFAULT_FEATURE_FLAGS: PartnerFeatureFlags = {
  gtreMspAgentAccessLicenseDrivenEnabled: false,
}

export const DEFAULT_PARTNER_ACCOUNT_SETTINGS = {
  featureFlags: DEFAULT_FEATURE_FLAGS,
  productSettings: DEFAULT_PARTNER_PRODUCT_SETTINGS,
}
export const PARTNER_FEATURE_FLAG_MAP_KEYS = {
  'gtre-msp-agent-access-license-driven-enabled': 'gtreMspAgentAccessLicenseDrivenEnabled',
}

export const mapPartnerFeatureFlags = (featureFlagsResponse: object): PartnerFeatureFlags => {
  const featureFlags = Object.entries(featureFlagsResponse).reduce((featureFlags, [key, value]) => {
    if (key in PARTNER_FEATURE_FLAG_MAP_KEYS) {
      featureFlags[PARTNER_FEATURE_FLAG_MAP_KEYS[key]] = value
    }
    return featureFlags
  }, {})

  return { ...DEFAULT_FEATURE_FLAGS, ...featureFlags }
}
